export enum ScheduledChannelSnapshotRunStatusType {
    UNKNOWN = 'UNKNOWN',
    PROCESSING = 'PROCESSING',
    SUCCESSFUL = 'SUCCESSFUL',
    PARTIALLY_SUCCESSFUL = 'PARTIALLY_SUCCESSFUL',
    FAILED = 'FAILED',
}
